// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ZiAp","buttons":"Footer_buttons__33wTy"};